import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';
import { componentRef } from './consts';

export default grapesjs.plugins.add('gjs-browser-storage-setter', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'browser-storage-setter',
    blocks: [componentRef],
    defaultStyle: true,
    labelTable: 'Browser Storage Setter',
    labelCMSCategory: 'CMS',
    labelFinderName: 'Filters',
    labelColName: 'Collection',
    labelFieldName: 'Collection Fields',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadTraits(editor, options);
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
